(function () {
  var el = document.getElementById('stusa-promo-config');
  if (!el) return;
  var CFG; try { CFG = JSON.parse(el.textContent); } catch (e) { return; }

  var K = { tree: 'stusa_tree_popup_seen', bundle: 'stusa_bundle_upsell_shown', nl: 'stusa_nl_seen', nlSub: 'stusa_nl_subscribed' };
  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} }
  };
  var ls = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k) { try { localStorage.setItem(k, '1'); } catch (e) {} }
  };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var dollars = function (n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); };
  var fill = function (tpl, vals) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return vals[k] != null ? vals[k] : m; }); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
  var nativeFetch = window.fetch.bind(window);

  var cart = null, cartCats = [], eligible = 0, prevQualifies = null;

  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; return c; });
  }
  function getData() {
    return nativeFetch('/?sections=stusa-tree-data', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['stusa-tree-data'] || '';
        var m = /data-eligible="(\d+)"/.exec(html), k = /data-cats="([^"]*)"/.exec(html);
        eligible = m ? parseInt(m[1], 10) / 100 : 0;
        cartCats = k ? k[1].split(',').filter(Boolean) : [];
      });
  }
  function refresh() { return Promise.all([getCart(), getData()]).then(function () { return cart; }); }

  function announce(c, variantId) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true,
        detail: { resource: c, sourceId: 'stusa-promos', data: { source: 'stusa-promos', itemCount: c.item_count, variantId: variantId } } }));
    } catch (e) {}
  }
  /* 3) Tracking: every add from our UI carries _source (hidden at checkout, visible on the order). */
  function addItem(variantId, source, extra) {
    var props = { _source: source };
    if (extra) for (var k in extra) props[k] = extra[k];
    return nativeFetch('/cart/add.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return refresh(); })
      .then(function (c) { announce(c, variantId); afterChange(); return c; });
  }
  function markSeen(attr) {
    var a = {}; a[attr] = '1';
    return nativeFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: a }) }).catch(function () {});
  }

  function openDialog(d) { if (d && !d.open) { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } } }
  function closeDialog(d) { if (d && d.open) { try { d.close(); } catch (e) { d.removeAttribute('open'); } } }
  function anyOpen() { return ['stusa-tree-pop', 'stusa-nl-pop', 'stusa-bundle-pop'].some(function (id) { var d = document.getElementById(id); return d && d.open; }); }

  function hasCode(c) {
    if ((c.discount_codes || []).some(function (d) { return d && d.applicable !== false; })) return true;
    if ((c.cart_level_discount_applications || []).some(function (a) { return a.type === 'discount_code'; })) return true;
    return (c.items || []).some(function (i) {
      return (i.line_level_discount_allocations || []).some(function (d) { return d.discount_application && d.discount_application.type === 'discount_code'; });
    });
  }
  var T = CFG.tree;
  function hasTree(c) { return T.variant && (c.items || []).some(function (i) { return i.variant_id === T.variant.id; }); }
  function treeQualifies(c) { return !!(T.enabled && T.variant && c && !hasTree(c) && !hasCode(c) && eligible >= T.threshold); }

  /* ---------- 2) Tree popup ---------- */
  var treeDlg = document.getElementById('stusa-tree-pop');
  function showTree() {
    ss.set(K.tree); markSeen('_seen_tree_popup');
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.close === 'function') { try { drawer.close(); } catch (e) {} }
    var nl = document.getElementById('stusa-nl-pop'); closeDialog(nl);
    setTimeout(function () { openDialog(treeDlg); }, 250);
  }
  function evaluateTree() {
    var q = treeQualifies(cart);
    if (!q) closeDialog(treeDlg);
    if (prevQualifies === null) { prevQualifies = q; if (q && !ss.get(K.tree)) showTree(); return; }
    if (!prevQualifies && q) showTree();
    prevQualifies = q;
  }
  function addTree(btn, source) {
    if (!T.variant || btn.disabled) return Promise.resolve();
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    return addItem(T.variant.id, source, { _free_dueling_tree: '1' })
      .then(function () { closeDialog(treeDlg); prevQualifies = false; })
      .catch(function () { var e = treeDlg.querySelector('.stusa-err'); if (e && source === 'tree_popup') e.hidden = false; })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  }
  if (treeDlg) {
    treeDlg.querySelectorAll('[data-stusa-tree-dismiss]').forEach(function (b) { b.addEventListener('click', function () { ss.set(K.tree); closeDialog(treeDlg); }); });
    var tb = treeDlg.querySelector('[data-stusa-tree-add]');
    if (tb) tb.addEventListener('click', function () { addTree(tb, 'tree_popup'); });
  }

  /* ---------- 1 + 2) Cart perks: free-shipping bar + tree progress ---------- */
  function perksHTML() {
    if (!cart || !cart.item_count) return '';
    var out = '';
    if (CFG.fs.enabled) {
      var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
      var need = Math.max(0, CFG.fs.threshold - sub);
      var pct = Math.min(100, CFG.fs.threshold ? sub / CFG.fs.threshold * 100 : 100);
      out += '<div class="stusa-perk' + (need ? '' : ' stusa-perk--done') + '"><p>' +
        (need ? 'You’re <strong>' + money(need) + '</strong> away from <strong>FREE shipping</strong>' : '<strong>You’ve unlocked FREE shipping!</strong>') +
        '</p><div class="stusa-bar" role="progressbar" aria-label="Progress toward free shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><span style="width:' + pct + '%"></span></div>' +
        (CFG.fs.note ? '<small>' + esc(CFG.fs.note) + '</small>' : '') + '</div>';
    }
    if (T.enabled && T.variant && !hasCode(cart)) {
      var vals = { price: dollars(T.offerPrice), threshold: dollars(T.threshold), remaining: dollars(Math.max(0, T.threshold - eligible)) };
      if (hasTree(cart)) {
        out += '<div class="stusa-perk stusa-perk--tree stusa-perk--done"><p><strong>' + esc(fill(T.inCartText, vals)) + '</strong></p></div>';
      } else if (eligible >= T.threshold) {
        out += '<div class="stusa-perk stusa-perk--tree"><p><strong>' + esc(fill(T.unlockedText, vals)) + '</strong></p><button type="button" class="stusa-btn-o" data-stusa-perk-tree>Add Tree for ' + vals.price + '</button></div>';
      } else if (eligible >= T.progressMin) {
        var tp = Math.min(100, eligible / T.threshold * 100);
        out += '<div class="stusa-perk stusa-perk--tree"><p>' + esc(fill(T.progressText, vals)).replace(vals.remaining, function () { return '<strong>' + vals.remaining + '</strong>'; }) +
          '</p><div class="stusa-bar"><span style="width:' + tp + '%"></span></div></div>';
      }
    }
    return out;
  }
  function placePerks() {
    var html = perksHTML();
    var targets = [];
    var drawerContent = document.querySelector('cart-drawer-component .cart-drawer__content');
    if (drawerContent) targets.push({ parent: drawerContent, before: drawerContent.querySelector('.cart-drawer__items') });
    if (document.body && /\/cart\/?$/.test(location.pathname)) {
      var page = document.querySelector('main cart-items-component');
      if (page) targets.push({ parent: page.parentElement, before: page });
    }
    targets.forEach(function (t) {
      var box = t.parent.querySelector(':scope > .stusa-perks');
      if (!html) { if (box) box.remove(); return; }
      if (!box) { box = document.createElement('div'); box.className = 'stusa-perks'; t.parent.insertBefore(box, t.before && t.before.parentElement === t.parent ? t.before : t.parent.firstChild); }
      if (box._stusaHtml !== html) { box.innerHTML = html; box._stusaHtml = html; }
      var btn = box.querySelector('[data-stusa-perk-tree]');
      if (btn && !btn._wired) { btn._wired = true; btn.addEventListener('click', function () { addTree(btn, 'cart_tree_bar'); }); }
    });
  }
  // Horizon re-renders the drawer on every cart change; put the perks back each time.
  var placing = false;
  var mo = new MutationObserver(function () {
    if (placing) return; placing = true;
    requestAnimationFrame(function () { placePerks(); placing = false; });
  });
  function watchDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (d) mo.observe(d, { childList: true, subtree: true });
    var p = document.querySelector('main cart-items-component');
    if (p) mo.observe(p.parentElement, { childList: true, subtree: true });
  }

  /* ---------- 6) Add-on popup at checkout ---------- */
  var B = CFG.bundle;
  var bundleDlg = document.getElementById('stusa-bundle-pop');
  var bundleList = bundleDlg && bundleDlg.querySelector('[data-stusa-bundle-list]');
  var goBtn = bundleDlg && bundleDlg.querySelector('[data-stusa-bundle-go]');
  var adding = false, shown = [];
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function inCart() { var ids = {}; (cart && cart.items || []).forEach(function (i) { ids[i.handle] = true; }); return ids; }
  function pick(cats, max, exclude) {
    var ids = inCart();
    var avail = B.items.filter(function (p) { return !ids[p.handle] && p.handle !== exclude; });
    var hit = [], rest = [];
    avail.forEach(function (p) { ((p['for'] || []).some(function (f) { return cats.indexOf(f) !== -1; }) ? hit : rest).push(p); });
    return shuffle(hit).concat(shuffle(rest)).slice(0, max);
  }
  function rowsInto(listEl, items, source, onDone) {
    var ids = inCart();
    listEl.innerHTML = '';
    items.forEach(function (p) {
      var row = document.createElement('div'); row.className = 'stusa-row';
      var name = p.variant ? p.title + ' – ' + p.variant : p.title;
      row.innerHTML = '<a class="stusa-row__img" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="' + esc(p.title) + '" width="56" height="56" loading="lazy">' : '') + '</a>' +
        '<div class="stusa-row__info"><p class="n"><a href="' + p.url + '">' + esc(name) + '</a></p><p class="pr">' + money(p.price) + '</p></div>';
      if (ids[p.handle]) {
        var ok = document.createElement('span'); ok.className = 'stusa-ok'; ok.textContent = '✓ Added'; row.appendChild(ok);
      } else {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'stusa-add'; b.textContent = '+ Add';
        b.addEventListener('click', function () {
          if (adding) return; adding = true; b.disabled = true; b.textContent = 'Adding…';
          if (onDone) onDone(true);
          addItem(p.id, source).catch(function () {}).finally(function () { adding = false; if (onDone) onDone(false); rowsInto(listEl, items, source, onDone); });
        });
        row.appendChild(b);
      }
      listEl.appendChild(row);
    });
  }
  function bundleBusy(busy) { if (goBtn) { goBtn.disabled = busy; goBtn.textContent = busy ? 'Adding to cart…' : 'Continue to Checkout'; } }
  function bundleShouldShow() {
    if (!B.enabled || !B.items.length || ss.get(K.bundle) || !cart || !cart.item_count) return false;
    var ids = inCart(); return B.items.some(function (p) { return !ids[p.handle]; });
  }
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"], a[href$="/checkout"]';
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest(CHECKOUT_SEL);
    if (!t || !bundleShouldShow()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    ss.set(K.bundle); markSeen('_seen_bundle_popup');
    shown = pick(cartCats, B.max || 5);
    rowsInto(bundleList, shown, 'bundle_popup', bundleBusy);
    openDialog(bundleDlg);
  }, true);
  if (bundleDlg) {
    bundleDlg.querySelectorAll('[data-stusa-bundle-close]').forEach(function (b) { b.addEventListener('click', function () { closeDialog(bundleDlg); }); });
    if (goBtn) goBtn.addEventListener('click', function () { if (adding) return; goBtn.disabled = true; window.location.href = '/checkout'; });
  }

  /* ---------- 4) Newsletter popup ---------- */
  var nlDlg = document.getElementById('stusa-nl-pop');
  function nlClose() {
    closeDialog(nlDlg);
    if (CFG.nl.treeAfterMs && !ss.get(K.tree)) {
      setTimeout(function () { if (!ss.get(K.tree) && treeQualifies(cart) && !anyOpen()) showTree(); }, CFG.nl.treeAfterMs);
    }
  }
  if (nlDlg) {
    nlDlg.querySelectorAll('[data-stusa-nl-close]').forEach(function (b) { b.addEventListener('click', nlClose); });
    nlDlg.addEventListener('cancel', function () { setTimeout(nlClose, 0); });
    var params = new URLSearchParams(location.search);
    var fromPopup = params.get('stusa_nl') === '1' || /StusaNewsletterPopup/.test(location.hash);
    var posted = params.get('customer_posted') === 'true' || fromPopup;
    var hadError = !!nlDlg.querySelector('[data-stusa-nl-error]');
    if (posted || hadError) {
      if (!hadError) {
        ls.set(K.nlSub);
        nlDlg.querySelector('[data-stusa-nl-form]').hidden = true;
        nlDlg.querySelector('[data-stusa-nl-ok]').hidden = false;
      }
      // Only reopen if this page load came from the popup form.
      if (hadError || fromPopup) openDialog(nlDlg);
    } else if (CFG.nl.enabled && !ls.get(K.nlSub) && !ss.get(K.nl) && !/\/(checkout|account)/.test(location.pathname)) {
      setTimeout(function () {
        if (anyOpen() || ss.get(K.nl)) return;
        ss.set(K.nl);
        openDialog(nlDlg);
      }, CFG.nl.delay || 2000);
    }
  }

  /* ---------- 5) Product page ---------- */
  var P = CFG.pdp;
  function initPDP() {
    if (P.isProduct !== 'product' || !P.handle) return;
    var details = document.querySelector('.product-details');
    if (!details) return;
    if (CFG.fs.pdpLine) {
      var price = details.querySelector('product-price');
      if (price && !details.querySelector('.stusa-pdp-ship')) {
        var ship = document.createElement('p'); ship.className = 'stusa-pdp-ship';
        ship.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg><span>' + esc(CFG.fs.pdpText).replace(/FREE shipping/i, '<b>$&</b>') + '</span>';
        price.insertAdjacentElement('afterend', ship);
      }
    }
    var formComp = details.querySelector('product-form-component');
    var anchor = formComp && formComp.parentElement;
    if (P.specLine && P.onlyDefault === false && anchor && !details.querySelector('.stusa-pdp-spec')) {
      var spec = document.createElement('div'); spec.className = 'stusa-pdp-spec';
      spec.innerHTML = '<b>You’re getting</b><span data-spec-title></span>';
      var setSpec = function (vt) { spec.querySelector('[data-spec-title]').textContent = P.title + ' – ' + vt; };
      setSpec(P.variantTitle || '');
      anchor.insertAdjacentElement('beforebegin', spec);
      document.addEventListener('variant:update', function (e) {
        var v = e && e.detail && e.detail.resource; if (v && v.title) setSpec(v.title);
      });
    }
    if (P.pairsEnabled && anchor && !details.querySelector('.stusa-pdp-pairs')) {
      var items = pick(P.cats || [], P.pairsCount || 3, P.handle).filter(function (p) {
        return (p['for'] || []).some(function (f) { return (P.cats || []).indexOf(f) !== -1; });
      });
      if (items.length) {
        var wrap = document.createElement('div'); wrap.className = 'stusa-pdp-pairs';
        wrap.innerHTML = '<h3 class="stusa-h">' + esc(P.pairsTitle) + '</h3><div data-pairs></div>';
        anchor.insertAdjacentElement('afterend', wrap);
        rowsInto(wrap.querySelector('[data-pairs]'), items, 'pdp_pairs');
      }
    }
  }

  /* ---------- Watch every cart change the theme makes ---------- */
  function afterChange() { placePerks(); evaluateTree(); }
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input instanceof URL ? input.href : (input && input.url) || '');
    var p = nativeFetch(input, init);
    if (CART_MUTATION.test(String(url).split('#')[0])) {
      p.then(function () { setTimeout(function () { refresh().then(afterChange).catch(function () {}); }, 150); }).catch(function () {});
    }
    return p;
  };

  refresh().then(function () {
    afterChange();
    watchDrawer();
    initPDP();
  }).catch(function () { initPDP(); });
})();
